import { motion } from "framer-motion";
import { useLanguage } from "@/i18n";

const Manifesto = () => {
  const { t } = useLanguage();
  const chapters = [
    { n: "01", title: t.manifesto.c1t, desc: t.manifesto.c1d, tid: "manifesto-chapter-1" },
    { n: "02", title: t.manifesto.c2t, desc: t.manifesto.c2d, tid: "manifesto-chapter-2" },
    { n: "03", title: t.manifesto.c3t, desc: t.manifesto.c3d, tid: "manifesto-chapter-3" },
  ];

  return (
    <section id="manifesto" className="border-b border-white/10" data-testid="manifesto-section">
      <div className="px-5 md:px-10 py-24 md:py-36">
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-mono text-[10px] md:text-xs tracking-[0.35em] text-thermal mb-16 md:mb-24"
          data-testid="manifesto-label"
        >
          {t.manifesto.label}
        </motion.p>

        <div className="space-y-20 md:space-y-32">
          {chapters.map((c, i) => (
            <motion.div
              key={c.tid}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
              className={`flex flex-col md:flex-row gap-6 md:gap-16 items-start ${i % 2 === 1 ? "md:flex-row-reverse" : ""}`}
              data-testid={c.tid}
            >
              <span className="font-mono font-bold text-[18vw] md:text-[10vw] leading-none text-outline shrink-0 select-none">
                {c.n}
              </span>
              <div className={`max-w-2xl ${i % 2 === 1 ? "md:text-right" : ""} md:pt-[3vw]`}>
                <h3 className="font-editorial italic font-medium text-3xl sm:text-4xl lg:text-5xl leading-tight mb-6">
                  {c.title}
                </h3>
                <p className="text-sm md:text-base text-white/55 leading-relaxed">{c.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
